export default {
  cancel: 'Abbrechen',
  logout: 'Ja, ausloggen',
  deactivate: 'Deaktivieren',
  edit: 'Bearbeiten',
  confirm: 'Bestätigen',
  request_leave: 'Urlaub anfragen',
  save: 'Speichern',
  add_route: 'Rayon hinzufügen',
  edit_route: 'Bearbeiten hinzufügen',
  export: 'Export',
  import: 'Import',
  activate: 'Aktivieren',
  btn_deactivate: 'Ja, deaktivieren',
  btn_activate: 'Ja, aktivieren',
  open_requests: 'Offene Anfragen',
  all_leaves: 'Alle Abwesenheiten',
  my_leave: 'Meine Abwesenheiten',
  reject: 'Ablehnen',
  yes_confirm: 'Ja, freigeben',
  yes_reject: 'Ja, ablehnen',
  send: 'Senden',
  approve: 'Freigeben',
  yes_delete: 'Ja, löschen',
  new_work_log: 'Neue Tätigkeit',
  end_journey: 'Tätigkeit beenden',
  edit_journey: 'Tätigkeitsdetails',
  delete_work_log: 'Stornieren',
  yes_delete_work_log: 'Ja, stornieren',
  send_reason: 'Bestätigen',
}
